<template>
  <div :class="$style.emptyStateWrapper">
    <img :src="image" alt="Empty state" :class="$style.emptyStateImage" />
    <h3 :class="$style.title">{{ title }}</h3>
    <p :class="$style.description">{{ description }}</p>
    <Button class="p-button p-button-primary" @click="emptyStateAction">
      {{ buttonText }}
    </Button>
  </div>
</template>

<script setup>
import emptyStateImage from "@/assets/ufo.png";
import Button from "primevue/button";

defineProps({
  image: {
    type: String,
    default: emptyStateImage,
  },
  title: {
    type: String,
    default: "No items available",
  },
  description: {
    type: String,
  },
  buttonText: {
    type: String,
    default: "New item",
  },
});

const emit = defineEmits(["emptyStateAction"]);

function emptyStateAction() {
  emit("emptyStateAction");
}
</script>

<style module>
.emptyStateWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 1rem;
  text-align: center;
  padding: 1rem;
}

.emptyStateImage {
  width: 100px;
}

.title {
  font-size: 24px;
  font-weight: 600;
}

.description {
  font-size: 14px;
  color: var(--vd-color-grey-light-2);
}
</style>
